import { render, staticRenderFns } from "./MessageSettings.vue?vue&type=template&id=2fe7472f&"
import script from "./MessageSettings.vue?vue&type=script&lang=js&"
export * from "./MessageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports